import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

const fallbackLocale = "en-US"
const loadedLanguages = []

const languages = {
	en: "en-US",
	es: "es-ES",
	pt: "pt-BR",
}

const i18n = new VueI18n({
	locale: fallbackLocale,
	fallbackLocale,
	messages: {}
})

function setI18nLanguage(lang) {
	i18n.locale = lang
	document.querySelector("html").setAttribute("lang", lang)
	return lang
}

export function loadLanguageAsync(lang) {
	if (loadedLanguages.includes(lang)) {
		return Promise.resolve(setI18nLanguage(lang))
	}

	localStorage.setItem("lang", lang)

	return import(
    /* webpackChunkName: "lang-[request]" */ `@/i18n/locales/${lang}/hiperme-${lang}.json`
	).then(messages => {
		i18n.setLocaleMessage(lang, messages.default || messages)
		loadedLanguages.push(lang)
		return setI18nLanguage(lang)
	})
}

let userLang = navigator.language || navigator.userLanguage
if (/-/.test(userLang)) {
	const key = userLang.split("-")[0]
	userLang = languages[key] || userLang 
}

const supportedLanguages = ["en-US", "es-ES", "pt-BR", "pr-PR"]
let initialLang = supportedLanguages.includes(userLang) ? userLang : fallbackLocale

if (localStorage.getItem("lang") && supportedLanguages.includes(localStorage.getItem("lang"))) {
	initialLang = localStorage.getItem("lang")
}

loadLanguageAsync(initialLang)

export default i18n
